import { computed } from 'vue';

export const useFieldDesc = listRef => {
	const firstDesc = computed(() => {
		const list = listRef?.value || [];
		if (!Array.isArray(list) || list.length === 0) return '';
		return list[0]?.desc || '';
	});

	return {
		firstDesc
	};
};
